const moduletemplates = {
	title: "Moduler",
	new_moduletemplate: "Ny modul",
	edit_moduletemplate: "Rediger modulmal: {name}",
	view_moduletemplate: "Vis modulmal: {name}",
	list_title: "Modulmaler",
	list_subtitle: "Endre modulmaler",
	create_title: "Ny modulmal",
	update_title: "Endre modulmal",
	details_title: "Modulmal",
	course_form_subtitle: "Valg av kompetanse tilgjengelig i kurs visning",
	id: "ID",
	name: "Navn",
	description: "Beskrivelse (vises på pdf, bør være kort)",
	req_hours: "Timer",
	req_module_id: "Obligatoriske moduler",
	req_coursetemplate_id: "Obligatoriske kurs",
	type: "Type",
	template_type: "Maltype",
	price: "Pris",
	price_vat: "MVA",
	status: "Status",
	is_included: "Er inkludert i prisen?",
	is_joint: "Er felles?",
	mandatory: "Minst 1 skal velges",
	created_by: "Opprettet av",
	expand_button_view_course_types: "Vis kurstyper",
	expand_button_close_course_types: "Lukk",
	save_first: "Modulmal må lagres først.",
	coursetype_id: "Kompetanse",
	coursetypegroup_id: "Kompetanseområder",
	add_to_expertise: "Selvstendig kompetanse",
	internal_note: "Intern notat",
	duplicate_message: "Vil du opprette en kopi av valgt mal?",
	available_module_templates: "Tilgjengelig moduler",
	import_success: "Modul maler er importert",
	import_failed: "Import av modul mal(er) har feilet",
	hide_in_accomplishment: "Skjul i progresjon",
	hide_in_enrolment: "Skjul i påmelding",
	hide_in_accomplishment_helptext: "Kryss av her hvis denne modulen ikke skal være inkludert i progresjon",
	required_module_course_helptext: "Med dette verktøyet kan du lage avhengihetsforhold mellom ulike kurselementer, eks der det er krav til en spesifikk rekkefølge i opplæringsløpet.",
	select_visibility: "Visningsvalg",
};
export default moduletemplates;